import React from 'react'

import { Network } from '@ambire-common/interfaces/network'
import { Animated, FlatListProps } from 'react-native'

import { TabType } from '@common/modules/dashboard/components/TabsAndSearch/Tabs/Tab/Tab'
import useAppMode from '@web/hooks/useAppMode'
import { ModeEnum } from '@web/contexts/appModeContext'

import ActivityPositions from './ActivityPositions'
import PrivateActivityPositions from './PrivateActivityPositions'

interface Props {
  openTab: TabType
  setOpenTab: React.Dispatch<React.SetStateAction<TabType>>
  initTab?: { [key: string]: boolean }
  sessionId: string
  onScroll: FlatListProps<any>['onScroll']
  animatedOverviewHeight: Animated.Value
  network: Network | null
}

const Activity = (props: Props) => {
  const { mode } = useAppMode()

  if (mode === ModeEnum.PRIVATE) {
    return <PrivateActivityPositions {...props} />
  }

  return <ActivityPositions {...props} />
}

export default React.memo(Activity)
